import { getQueryParam } from '@app/utils/url-helpers'

export const openNewAdjustmentModal = (newAdjustmentPath?: string): void => {
  if (!newAdjustmentPath) {
    return
  }

  const url = newAdjustmentPath
  const stringArray = url.split('?')
  const accountEntryIdParam = getQueryParam('account_entry_id', stringArray[1])
  const accountEntryId =
    typeof accountEntryIdParam === 'string'
      ? parseInt(accountEntryIdParam, 10)
      : undefined

  window.modalCitizen.openModalPortal('adjustments-modal', {
    accountEntryId,
    mode: 'new',
  })
}
